export default `   (                  )            )  
 ( )\\ (     (    ) ( /(      (  ( /(  
 )((_))(   ))\\( /( )\\())(   ))\\ )\\()) 
((_)_(()\\ /((_)(_)|(_)\\ )\\ /((_|_))/  
| _ )((_|_))((_)_| |(_|(_|_))(| |_   
| _ \\ '_/ -_) _' | / / _ \\ || |  _|  
|___/_| \\___\\__,_|_\\_\\___/\\_,_|\\__|
 [__][__][__][__][__][__][__][__]                         
 [__][__]by Hugo Enterprises [__]
 [__][__]** *[__][__][__][__][__]
 [__][__] /?                 [__]
 [__]*●  /         
       \\/                       
      ████                 
`
